module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_c('v-panel', {
    attrs: {
      "contextual-style": "primary"
    }
  }, [_c('h1', {
    staticClass: "panel-title",
    slot: "heading"
  }, [_vm._v("\n      System Configuration\n    ")]), _vm._v(" "), _c('div', {
    slot: "body"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-3"
  }, [_c('ul', {
    staticClass: "nav nav-pills nav-stacked"
  }, [_c('li', {
    staticClass: "active",
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("List Management")])]), _vm._v(" "), _c('li', {
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Profile")])]), _vm._v(" "), _c('li', {
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Messages")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-9"
  }, [_c('p', [_vm._v("\n          Please select an option from the menu above\n        ")]), _vm._v(" "), _c('p', [_c('br')]), _vm._v(" "), _c('p', [_vm._v("\n          For support, please contact Bypass support: "), _c('a', {
    attrs: {
      "href": "mailto:support@bypass.net.nz"
    }
  }, [_vm._v("support@bypass.net.nz")])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "btn btn-primary",
    attrs: {
      "href": "mailto:support@bypass.net.nz",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope fa-fw",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "padding-left"
  }, [_vm._v("Contact")])])])])]), _vm._v(" "), _c('div', {
    slot: "footer"
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b0e8dee"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/pages/config/index/index.vue
// module id = 220
// module chunks = 1